export default __webpack_public_path__ + "static/media/popup_percent.1e6af35f.svg";